<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <div class="font-weight-bold mb-3">
              <span v-if="contractGetPacketFiltering.packetFilterEnabled"
                >パケットフィルタリングを解約します。よろしいですか？</span
              >
              <span v-else
                >パケットフィルタリングを契約します。よろしいですか？</span
              >
            </div>
            <v-row>
              <v-col>
                <app-label-group label="パケットフィルタリング契約">
                  <template #value>
                    <div class="ml-3 text-red">
                      {{
                        $filter.enumTo(
                          !contractGetPacketFiltering.packetFilterEnabled,
                          "contractChangeStatus"
                        )
                      }}
                    </div>
                  </template>
                </app-label-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <app-label-group
                  label="ルール数"
                  :value="`${contractGetPacketFiltering.packetFilterRuleCount} 個`"
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい </v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { ContractGetPacketFiltering } from "@/apis/PacketFilteringApi";

export default defineComponent({
  name: "PacketFilteringContractConfirm",
  props: {
    contractGetPacketFiltering: {
      type: Object as PropType<ContractGetPacketFiltering>,
      required: true,
    },
  },
});
</script>
